import ReactDirective from "acl-ui/angular/reactDirective.umd";
import Spinner from "acl-ui/components/Spinner";

angular.module("acl.visualizer.loadingAnimation", []).directive("acluiSpinner", ReactDirective.getFactory(Spinner));
